import { IFeature } from 'mod/featureV2/interface';

export const anchorsBanner: IFeature = {
    type: 'anchorsBanner',
    moduleId: 'anchorsBanner',
    title: 'anchorsBanner',
    description: 'description',
    config: {
        width: 375,
        height: 500,
        bgColor: '#c9d9ce',
        type: 'grid',
        grid: {
            column: 1,
            gutter: 20
        }
    },
    list: [
        {
            src: 'asset/width-1500/picture/1f29f55f7da3224f6ce1cb181c3f3438.jpg',
            alt: 'test',
            anchors: [
                {
                    x: 375 / 5,
                    y: 500 / 5,
                    clickType: 'QUICK_VIEW',
                    variantId: '58820960379616584'
                },
                {
                    x: 375 / 3,
                    y: 500 / 3,
                    clickType: 'BUBBLE',
                    bubble: {
                        placement: 'bottom',
                        tip: 'Hassle-free setup',
                        button: {
                            text: 'Explorer',
                            href: '/promotional-sale?mock=1',
                            type: 'base',
                            size: 'small',
                            shape: 'round',
                        },
                    }
                },
                {
                    x: 375 / 1.2,
                    y: 500 / 1.2,
                    clickType: 'BUBBLE',
                    bubble: {
                        placement: 'top',
                        tip: 'Hassle-free setup in minutes without tools Full-spectrum Led grow lights for horticulture with adjustable spectrum Patented multi-layer circulation',
                        button: {
                            text: 'Explorer',
                            href: '/promotional-sale?mock=1',
                            type: 'base',
                            size: 'small',
                            shape: 'round',
                        },
                    }
                },
            ]
        },
    ]
};
